import * as React from 'react';
import { makeStyles, createStyles, Theme, lighten, withStyles } from '@material-ui/core/styles';
import MaterialTable, { Column } from 'material-table';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { Button, IconButton, Typography, } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { MaterialFilesData } from 'src/reducers/materialFiles';
import LinearProgress from '@material-ui/core/LinearProgress';

interface TableState {
    columns: Array<Column<MaterialFilesData>>;
    data: MaterialFilesData[];
}

export interface MaterialFilesUploadViewProps {
    materialprogress: number;
    materialfiles: string;
    materialFilesData: MaterialFilesData[];
    onSubmit: () => void;
    onClear: () => void;
    saveMaterialfiles: (customermaterialfiles: File) => void;
}
const BorderLinearProgress = withStyles({
    root: {
        height: 8,
        backgroundColor: lighten('#3f51b5', 0.5),
    },
    bar: {
        borderRadius: 20,
        backgroundColor: '#3f51b5',
    },
})(LinearProgress);
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootMaterialFilePage: {
            '& .MuiToolbar-regular': {
                minHeight: '0px !important'
            },
            flexGrow: 1,
            height: 'calc(90vh - 64px)  '

        },
        uploadSection: {
            display: 'flex',
            justifyContent: 'space-between',
            margin: '20px 0px',
            alignItems: 'center'
        },
        input: {
            display: 'none',
        },
        fileDisplay: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(1),
        },
        inputSection: {
            display: 'flex',
            gap: '30px',
            alignItems: 'center'
        },
        progress: {
            fontSize: '0.7rem',
            color: '#FFBF00'
        },
        progressError: {
            fontSize: '0.7rem',
            color: '#D2222D'
        },
        progressComp: {
            fontSize: '0.7rem',
            color: '#007000'
        },
    })
);

const MaterialFilesUploadView: React.StatelessComponent<MaterialFilesUploadViewProps> = props => {
    const classes = useStyles({});
    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Sno',
                field: 'rowno',
                cellStyle: {
                    width: '300px',
                    // minWidth: '300px'
                },
            },
            {
                title: 'File Name',
                field: 'custfile',
                cellStyle: {
                    width: '300px',
                    // minWidth: '300px'
                },
            },

            {
                title: 'Uploaded By',
                field: 'custname',
                cellStyle: {
                    width: '300px',
                    // minWidth: '300px'
                },
            },
            {
                title: 'Uploaded On ',
                field: 'uploadedon',
                cellStyle: {
                    width: '300px',
                    // minWidth: '300px'
                },
            },

        ],
        data: props.materialFilesData
    });
    const [selectedFile, setSelectedFile] = React.useState<File | null>(null);
    const MAX_FILE_SIZE = 8 * 1024 * 1024 * 1024;
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.onClear();
        const file = event.target.files && event.target.files[0];
        if (file && file.size < MAX_FILE_SIZE) {
            setSelectedFile(file);
            props.saveMaterialfiles(file);
        } else {
            alert('File size exceeds the limit of 8GB');
        }
    };
    const handleRemoveFile = () => {
        setSelectedFile(null);
        props.onClear();

    };

    // console.log(selectedFile, 'selected Material Files');

    // const handleDownload = (rowData: MaterialFilesData) => {
    //     const anchorElement = document.createElement('a');
    //     // anchorElement.href = rowData;
    //     console.log('download', rowData)
    //     anchorElement.download = 'file';
    //     anchorElement.click();
    // }
    return (
        <div className={classes.rootMaterialFilePage}>
            <div className="mx-3">
                <h2>Material Files (DME)</h2>
            </div>
            <div className={classes.uploadSection}>

                <div className={classes.inputSection}>
                    <input
                        className={classes.input}
                        id="file-input"
                        type="file"
                        accept=".dme, .zip"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="file-input">
                        <Button variant="contained" component="span">
                            Choose File
                        </Button>
                    </label>
                    {selectedFile && (
                        <div className={classes.fileDisplay}>
                            <div>
                                <Typography variant="body1">{selectedFile.name}</Typography>
                                {props.materialfiles === 'uploading' ?
                                    <div className={classes.progress}>Upload In-Progress</div>
                                    : (
                                        props.materialfiles === 'uploadfailed'
                                        &&
                                        <div className={classes.progressError}>
                                            Upload error
                                        </div>
                                    )
                                }
                                {props.materialprogress > 0 ?
                                    <BorderLinearProgress
                                        className={classes.margin}
                                        variant="determinate"
                                        value={props.materialprogress}

                                    />
                                    : null}
                                {props.materialprogress > 0
                                    && props.materialfiles === 'uploaded'
                                    && <div className={classes.progressComp}>File uploaded</div>
                                }
                            </div>
                            <IconButton onClick={handleRemoveFile}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    )}
                </div>
                <div>
                    {selectedFile == null && (
                        <Button type="button" variant="outlined" color="primary" disabled>
                            Send
                        </Button>
                    ) || (
                            <Button type="button" variant="outlined" color="primary" onClick={props.onSubmit}>Send</Button>

                        )}
                </div>
            </div>
            <div>
                <p>Note: Only the latest uploaded material file (DME) will be considered.
                </p>
            </div>
            <MaterialTable
                title=""
                columns={state.columns}
                data={props.materialFilesData || []}
                localization={{
                    header: {
                        actions: 'Download'
                    },
                }}
                options={{
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    sorting: true,
                    actionsColumnIndex: -1,
                    headerStyle: {
                        backgroundColor: '#757575',
                        color: '#fff'
                    },
                    search: false,
                    paging: true
                }}
                actions={[
                    {
                        icon: () => (
                            <CloudDownloadIcon color="primary" />
                        ),
                        tooltip: 'Download',
                        onClick: (event, rowData: MaterialFilesData) => {
                            const anchorElement = document.createElement('a');
                            anchorElement.href = rowData.action;
                            anchorElement.download = 'file';
                            anchorElement.click();
                        }
                    },
                    // {
                    //     icon: 'chevron_right',
                    //     tooltip: 'view',
                    //     onClick: (event, rowData) => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))
                    // }
                ]}
            />
        </div>
    );
};

export default MaterialFilesUploadView;



// WEBPACK FOOTER //
// ./src/components/layouts/MaterialFilesUploadView.tsx